import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import useLaunchDarklyFlags from "@MasterBluePrint/Common/Hooks/useLaunchDarklyFlags";
import { LaunchDarklyFlagKeys } from "@MasterBluePrint/Common/Utilities/LaunchDarklyFlagKeys";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
    cantbuyText: TypographyPresentationProps;
}

export const priceStyles: ProductDetailsPriceStyles = {
    productPrice: {
        price: {
            priceText: { size: 26 },
            unitOfMeasureText: { size: 26 },
        },
    },
    cantbuyText: {
        css: css`
            color: #C53527;
            font-family: Roboto;
            font-size: 26px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        `
    }

};

const styles = priceStyles;

const ProductDetailsPrice: React.FC<OwnProps> = ({ productContext, productSettings }) => {
    const cantBuy = "product" in productContext ? productContext.product.cantBuy: false;
    const featureFlags: string[] = [LaunchDarklyFlagKeys.TEUS_9014];
    const flagValues = useLaunchDarklyFlags({ featureFlags });
    const isFeatureFlag = flagValues[LaunchDarklyFlagKeys.TEUS_9014];
    if(isFeatureFlag && cantBuy) {
        return (
            <StyledWrapper>
                <Typography {...styles.cantbuyText}>
                    {siteMessage("CantBuyProductPriceMessageText")}
                </Typography>
            </StyledWrapper>
        )
    }
    return (
        <ProductPrice
            product={productContext}
            showLabel={false}
            showSavings={true}
            showSavingsAmount={productSettings.showSavingsAmount}
            showSavingsPercent={productSettings.showSavingsPercent}
            extendedStyles={styles.productPrice}
            frompage='productdetails'
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(ProductDetailsPrice)),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
